<template>
  <div class="" style="background-color: #f7f7f7; min-height: 100vh">
    <div class="box">
      <van-field
        v-model="form.name"
        label="需求名称"
        placeholder="请输入需求名称"
      />
      <van-field
        v-model="form.content"
        label="需求详情"
        placeholder="请输入需求详情"
        type="textarea"
        rows="2"
        maxlength="300"
        autosize
        show-word-limit
      />
      <van-field name="uploader" label="图片">
        <template #input>
          <!-- capture="camera" -->
          <van-uploader
            v-model="uploader"
            multiple
            class="imgs"
            :max-count="9"
            :after-read="afterRead"
            :before-delete="jkDelete"
            :deletable="true"
          />
        </template>
      </van-field>
      <van-field
        type="number"
        v-model="form.phone"
        label="手机号"
        placeholder="请输入手机号"
      />
      <van-field
        type="number"
        v-model="form.price"
        label="价格(元)"
        placeholder="请输入价格(元)"
      />
      <van-field name="radio" label="买卖类型">
        <template #input>
          <van-radio-group v-model="form.tradeType" direction="horizontal">
            <van-radio checked-color="#f36e86" name="1">买服务</van-radio>
            <van-radio checked-color="#f36e86" name="2">卖服务</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        name="picker"
        :value="form.authName"
        label="权限类型"
        placeholder="点击选择权限类型"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          value-key="name"
          show-toolbar
          :columns="CategoryList"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        name="picker"
        :value="form.demandName"
        label="需求类型"
        placeholder="点击选择需求类型"
        @click="showPicker1 = true"
      />
      <van-popup v-model="showPicker1" position="bottom">
        <van-picker
          value-key="name"
          show-toolbar
          :columns="demandTypeList"
          @confirm="onConfirm1"
          @cancel="showPicker1 = false"
        />
      </van-popup>
    </div>
    <div style="text-align: center; margin-top: 50px">
      <button class="bottomBtn" @click="addDemand">发布</button>
    </div>
  </div>
</template>

<script>
import {
  getPlatform,
  getUrl,
  getStoreId,
  getOpenId,
  getIntegral,
} from "@/utils/auth";
import axios from "axios";
import config from "@/config";
import Compressor from "compressorjs";
import { Toast, Dialog } from "vant";
import {
  listTableCategory1,
  listTableCategory2,
  addDemane,
} from "@/api/demand";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      CategoryList: [],
      demandTypeList: [],
      showPicker: false,
      showPicker1: false,
      uploader: [],
      form: {
        name: "",
        content: "",
        img: "",
        phone: "",
        price: "",
        tradeType: "",
        authName: "",
        authType: "",
        demandName: "",
        demandType: "",
        userId: "",
        platformId: getPlatform(),
        userType: "",
      },
      ImgsList: [],
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    /** 获取权限类型 下拉选 */
    async getCategory() {
      const res = await listTableCategory1({ pageNum: 1, pageSize: 999 });
      this.CategoryList = res.data.data.list;
    },
    /** 获取需求类型 下拉选 */
    async getCategory2() {
      const res = await listTableCategory2({ pageNum: 1, pageSize: 999 });
      this.demandTypeList = res.data.data.list;
    },
    // 权限类型 确认
    onConfirm(val) {
      console.log(val);
      this.form.authName = val.name;
      this.form.authType = val.id;
      this.showPicker = false;
    },
    // 需求类型 确认
    onConfirm1(val) {
      console.log(val);
      this.form.demandName = val.name;
      this.form.demandType = val.id;
      this.showPicker1 = false;
    },
    //上传图片
    afterRead(file) {
      var that = this;
      file.status = "uploading";
      file.message = "上传中...";
      new Compressor(file.file, {
        quality: 0.5,
        success(result) {
          var formData = new FormData();
          let c = {
            headers: { "Content-Type": "multipart/form-data" },
          };
          //构造一个 FormData，把后台需要发送的参数添加
          formData.append("file", result, result.name);
          axios.post(config.apiUploadUrl, formData, c).then((res) => {
            if (res.data.code === 200) {
              console.log(res.data);
              // that.datafrom.HealthCode = res.data.data
              that.ImgsList.push(res.data.data);
              file.status = "";
              file.message = "";
            } else {
              Toast.fail(res.data.msg);
            }
          });
        },
      });
    },

    //删除图片
    jkDelete(file, detail) {
      var that = this;
      that.ImgsList.splice(detail.index, 1);
      this.uploader.splice(detail.index, 1);
    },

    // 发布
    addDemand() {
      this.form.img = this.ImgsList + "";
      if (!this.form.name) {
        Toast.fail("需求名称不能为空");
        return false;
      }
      if (!this.form.phone) {
        Toast.fail("手机号不能为空");
        return false;
      }
      if (!this.form.price) {
        Toast.fail("价格不能为空");
        return false;
      }
      if (!this.form.tradeType) {
        Toast.fail("请选择买卖类型");
        return false;
      }
      if (!this.form.authType) {
        Toast.fail("请选择权限类型");
        return false;
      }
      if (!this.form.demandType) {
        Toast.fail("请选择需求类型");
        return false;
      }
      console.log(this.form);
      var that = this;
      addDemane(that.form).then((res) => {
        if (res.data.code == 200) {
          Toast.success("发布成功");
          setTimeout(() => {
            if (window.__wxjs_environment === "miniprogram") {
              wx.miniProgram.redirectTo({
                // delta: 1,
                url:
                  "/pages/demand/index?integral=" +
                  getIntegral() +
                  "&platformId=" +
                  getPlatform() +
                  "&url=" +
                  getUrl() +
                  "&openId=" +
                  getOpenId() +
                  "&storeId=" +
                  getStoreId(),
              });
            } else {
              // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
              that.$router.push("/demand/index");
            }
          }, 1000);
        }
      });
    },

    // 获取用户信息
    getUserInfo() {
      var that = this;
      console.log(getUrl(), 111111111);
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/userInfo";
      const params = { userId: getOpenId() };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          //   that.userName = response.data.data.nickName;
          //   that.headImgUrl = response.data.data.headImgUrl;
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },
  },
  created() {},
  mounted() {
    this.getCategory();
    this.getCategory2();
    if (getStoreId() && getStoreId() != "null") {
      this.form.userId = getStoreId();
      this.form.userType = 2;
    } else {
      this.form.userId = getOpenId();
      this.form.userType = 1;
    }
    this.getUserInfo();
  },
};
</script> 

<style scoped>
.bottomBtn {
  background: #f36e86;
  border-radius: 22px;
  border: none;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #fff;
  width: 94%;
  padding: 11.5px 0;

  margin-top: 7.5px;
}
</style>